/* eslint-disable */
(function($){

    $(document).on("mouseenter","html.no-mobile header ul li.menu-item-has-children", function(){
        //$(this).find(".sub-menu").stop().fadeIn("fast");
		TweenLite.to($(this).find(".sub-menu"), 0.3, {ease: Expo.easeIn, autoAlpha:1 });
		$(this).addClass('item-active');
    });

    $(document).on("mouseleave","html.no-mobile header ul li.menu-item-has-children", function(){
        //$(this).find(".sub-menu").stop().fadeOut("fast");
		TweenLite.to($(this).find(".sub-menu"), 0.3, {ease: Expo.easeIn, autoAlpha:0 });
		$(this).removeClass('item-active');
    });

    $(document).on("click","html.mobile header ul li.menu-item-has-children", function(evt){
        evt.preventDefault();
        if($(this).hasClass('item-active')){
            TweenLite.to($(this).find(".sub-menu"), 0.3, {ease: Expo.easeIn, autoAlpha:0 });
            $(this).removeClass('item-active');
        }else{
            TweenLite.to($(this).find(".sub-menu"), 0.3, {ease: Expo.easeIn, autoAlpha:1 });
            $(this).addClass('item-active');
        }
        //$(this).toggleClass('')
        //$(this).find(".sub-menu").stop().fadeToggle("fast");
    });


    /* ********** Click - Site Header Menu Button ********** */
    $(document).on("click","#site-header .menu-button, #mobile-menu-container .menu-button-close", function(){
        //TweenLite.to($('#mobile-menu-container'), 0.4, {ease: Power2.easeOut, left:'0%' });
        $('#mobile-menu-container').addClass('active');
        $('.content-blur-menu').addClass('active');
    });

    $(document).on("click",".content-blur-menu, #mobile-menu-container .menu-button-close", function(){
        //TweenLite.to($('#mobile-menu-container'), 0.4, {ease: Power2.easeOut, left:'-100%' });
        $('#mobile-menu-container').removeClass('active');
        $('.content-blur-menu').removeClass('active');
    });


    /* ********** Click - Header Component Hamburger Menu ********** */
    var $targetCHM = $('.component-hamburger-menu');
    var $targetCTHM = $('.component-toggle-hamburger-menu');
    var $targetCTHM2 = $('.component-toggle-hamburger-menu-2');
    var targetAnimElement;
    $(document).on("click",".component-hamburger-menu", function(){
        $targetCHM = $('.component-hamburger-menu');
        $targetCTHM = $('.component-toggle-hamburger-menu');
        $targetCTHM2 = $('.component-toggle-hamburger-menu-2');
        targetAnimElement;

        //if($(window).width() > 850){
            //targetAnimElement = 'ul.list-nav > li:not(.show-responsive), .element-animate';
        //}else{
            targetAnimElement = 'ul.nav > li, .element-animate';
        //}

        if($(this).hasClass('active-2')){
            closeHamburgerMenuOne($targetCHM, $targetCTHM); //Close Hamburger Menu One
            closeHamburgerMenuTwo($targetCHM, $targetCTHM2); //Close Hamburger Menu Two
        }else{
            if(!$(this).hasClass('active')){
                TweenLite.to($targetCTHM, 0, {ease: Power1.easeIn, right:'0' });
                TweenLite.to($targetCTHM.find('.block-animate'), 0.3, {ease: Power1.easeOut, width:'100%' });
                TweenLite.to($targetCTHM.find(targetAnimElement), 0, {ease: Power1.easeIn, opacity:1, scale:1, x:0, y:0 });
                TweenMax.staggerFrom($targetCTHM.find(targetAnimElement), 0.6, {ease: Power2.easeOut, delay:0.2, opacity:0, scale:1.1, x:-10, y:-20}, 0.04);
                TweenLite.to($targetCTHM.find('.content-canvas, .content-mask'), 0, {ease: Power1.easeIn, opacity:0 });
                TweenLite.to($targetCTHM.find('.content-canvas, .content-mask'), 0.6, {ease: Power1.easeIn, delay:0.3, opacity:1 });
                $targetCHM.addClass('active');
                $targetCTHM.addClass('menu-active');
            }else{
                closeHamburgerMenuOne($targetCHM, $targetCTHM); //Close Hamburger Menu One
            }

           //$('body').toggleClass('fixed-mobile');
        }
    });

    var valueStringUl;
    //$(document).on("click",".component-toggle-hamburger-menu ul li.dropdown a", function(evt){
    $(document).on("click",".component-toggle-hamburger-menu ul li.menu-item-has-children a", function(evt){
		evt.stopPropagation();
		evt.preventDefault();
		
		// Comportement Dropdown Toggle
		/*if(!$(this).hasClass('dropdown-active')){
            $(this).find(".sub-menu").slideDown();
            $(this).addClass('dropdown-active');
        }else{
            $(this).find(".sub-menu").slideUp();
            $(this).removeClass('dropdown-active');
        }*/

        var valueStringUl = '';
        $($(this).parent().find("ul")).each(function(index){
            valueStringUl += $(this).html();
        });

		$targetCTHM2.find('.content-js').html(valueStringUl);

        TweenLite.to($targetCTHM2, 0, {ease: Power1.easeIn, left:'0' });
        TweenLite.to($targetCTHM2.find('.block-animate'), 0.4, {ease: Power1.easeIn, width:'100%' });

        TweenLite.to($targetCTHM2.find('li, .element-animate'), 0, {ease: Power1.easeIn, opacity:1, scale:1, x:0, y:0 });
        TweenMax.staggerFrom($targetCTHM2.find('li, .element-animate'), 0.6, {ease: Power2.easeOut, delay:0.3, opacity:0, scale:1.1, x:-10, y:-20}, 0.04);

        $targetCHM.addClass('active-2');
    });

    $(document).on("click",".component-back-hamburger-menu", function(evt){
        closeHamburgerMenuTwo($targetCHM, $targetCTHM2); //Close Hamburger Menu Two
    });

    /* ********** Component Toggle Hamburger Menu - Content Mask ********** */
    $(document).on("click", ".component-toggle-hamburger-menu .content-mask", function(){
        closeHamburgerMenuOne($targetCHM, $targetCTHM); //Close Hamburger Menu One
        closeHamburgerMenuTwo($targetCHM, $targetCTHM2); //Close Hamburger Menu Two
    });

    /* ********** Main Header Dropdown Menu ********** */
    var targetMainHeaderDropdown = $('#main-header li a');
    var targetComponentMenuDropdown = $('.component-menu-dropdown');
    $(document).on("mouseover mouseenter", ".no-mobile #main-header li.dropdown a, .component-menu-dropdown", function(){
        TweenLite.to(targetComponentMenuDropdown, 0.3, {ease: Power2.easeOut, autoAlpha:1, display:'block', oncomplete:menuAddClass });
    });

    $(document).on("mouseleave", ".no-mobile #main-header li.dropdown a, .component-menu-dropdown", function(){
        TweenLite.to(targetComponentMenuDropdown, 0.3, {ease: Power2.easeOut, autoAlpha:0, display:'none', oncomplete:menuRemoveClass });
    });

    $(document).on("click", ".mobile #main-header li.dropdown a", function(){
        if($(this).hasClass('children-dropdown-active')){
            $(this).removeClass('children-dropdown-active');
            TweenLite.to(targetComponentMenuDropdown, 0.3, {ease: Power2.easeOut, autoAlpha:0, display:'none', oncomplete:menuRemoveClass });
        }else{
            $(this).addClass('children-dropdown-active');
            TweenLite.to(targetComponentMenuDropdown, 0.3, {ease: Power2.easeOut, autoAlpha:1, display:'block', oncomplete:menuAddClass });
        }
    });

    function menuAddClass(){
        $('#main-header li.dropdown a').addClass('dropdown-active');
    }

    function menuRemoveClass(){
        targetMainHeaderDropdown.removeClass('dropdown-active');
    }

    $(document).on("mouseenter", ".no-mobile #main-header li a", function(){
        targetMainHeaderDropdown.removeClass('dropdown-active');
        $(this).addClass('dropdown-active');
    });

    $(document).on("click", ".mobile #main-header li a", function(){
        if($(this).hasClass('dropdown-active')){
            targetMainHeaderDropdown.removeClass('dropdown-active');
        }else{
            targetMainHeaderDropdown.removeClass('dropdown-active');
            $(this).addClass('dropdown-active');
        }
    });

    $(document).on("mouseover mouseenter", ".no-mobile #main-header li.menu-item-has-children .sub-menu", function(){
        $(this).parent().find("a").addClass('dropdown-active');
    });

    $(document).on("mouseleave", ".no-mobile #main-header li.menu-item-has-children .sub-menu, #main-header li.menu-item-has-children:not(.dropdown)", function(){
        targetMainHeaderDropdown.removeClass('dropdown-active');
    });

    $(document).keyup(function(e){
        /* Close Menu Mobile - Escape Key */
        if(e.keyCode == 27){
            closeHamburgerMenu($targetCHM, $targetCTHM, $targetCTHM2);
        }
    });

})(jQuery);

function closeHamburgerMenuOne($targetCHM, $targetCTHM){
    //if($(window).width() > 850){
        //targetAnimElement = 'ul.list-nav > li:not(.show-responsive), .element-animate';
    //}else{
        targetAnimElement = 'ul.nav > li, .element-animate';
    //}
    TweenMax.staggerTo($targetCTHM.find(targetAnimElement), 0.6, {ease: Power2.easeOut, opacity:0, scale:1.1, x:-10, y:-20}, -0.04);
    TweenLite.to($targetCTHM.find('.block-animate'), 0.3, {ease: Power1.easeIn, delay:0.4, width:'0%' });
    TweenLite.to($targetCTHM, 0, {ease: Power1.easeIn, delay:0.8, right:'-100%' });

    //TweenLite.to($targetCTHM.find('.content-canvas, .content-mask'), 0.4, {ease: Power1.easeIn, opacity:0 });

    $targetCHM.removeClass('active');
    $targetCTHM.removeClass('menu-active');
}

function closeHamburgerMenuTwo($targetCHM, $targetCTHM2){
	TweenMax.staggerTo($targetCTHM2.find('li, .element-animate'), 0.6, {ease: Power2.easeOut, opacity:0, scale:1.05, x:-5, y:-10}, -0.02);

    TweenLite.to($targetCTHM2.find('.block-animate'), 0.4, {ease: Power1.easeIn, delay:0.4, width:'0' });
    TweenLite.to($targetCTHM2, 0, {ease: Power1.easeIn, delay:0.8, left:'100%' });

    $targetCHM.removeClass('active-2');
}

function closeHamburgerMenu($targetCHM, $targetCTHM, $targetCTHM2){
    closeHamburgerMenuOne($targetCHM, $targetCTHM); //Close Hamburger Menu One
    closeHamburgerMenuTwo($targetCHM, $targetCTHM2); //Close Hamburger Menu Two
}


// WEBPACK FOOTER //
// ./scripts/modules/hamburger-menu.js